module.exports = __webpack_public_path__ + "static/portfolio_gallery_3-3aa69f3dcb6b1e46ae86778dc3f61278.jpg";